export const concatWeb3Address = (address: string) => {
  if (!address) {
    return '';
  }
  const firstSeven = address.substring(0, 12);
  const lastOne = address.slice(-3);
  return `${firstSeven}...${lastOne}`;
};

export const concatTransactionHash = concatWeb3Address;
